function Calendar() {
  return (
    <div>
      <h1>Kalender</h1>
    </div>
  );
}

export default Calendar;
